import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Sentry } from './lib/sentry'
import SentryErrorFallback from './components/SentryErrorFallback'
import { ThemeProvider } from './components/theme-provider'
import { AuthProvider } from './context/AuthContext'
import { OrganizationProvider } from './context/OrganizationContext'
import { ToastProvider } from './context/ToastContext'
import { UIProvider } from './context/UIContext'
import { DashboardLayout } from './layouts/DashboardLayout'
import DashboardHome from './pages/DashboardHome'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import OrganizationCreate from './pages/organizations/OrganizationCreate'
import OrganizationDetail from './pages/organizations/OrganizationDetail'
import OrganizationEdit from './pages/organizations/OrganizationEdit'
import OrganizationList from './pages/organizations/OrganizationList'
import StoreEdit from './pages/organizations/StoreEdit'
import StoreDetail from './pages/organizations/StoreDetail'
import StoreWebhookLogsPage from './pages/organizations/StoreWebhookLogsPage'
import PosRemittancePage from './pages/organizations/PosRemittancePage'
import Settings from './pages/Settings'
import LegalImprintPage from './pages/legal/ImprintPage'
import PlatformPricingPage from './pages/pricing/PlatformPricingPage'
import PaymentGatewaysPage from './pages/payment-gateways/PaymentGatewaysPage'
import WithdrawalsPage from './pages/withdrawals/WithdrawalsPage'
import StoreAuditPage from './pages/withdrawals/StoreAuditPage'
import StoreAuditTransactionDetailPage from './pages/withdrawals/StoreAuditTransactionDetailPage'
import NewsletterOverviewPage from './pages/newsletters/NewsletterOverviewPage'
import PlatformTeamPage from './pages/platform/PlatformTeamPage'
import ContactMessagesPage from './pages/messages/ContactMessagesPage'

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<DashboardLayout />}>
        <Route index element={<DashboardHome />} />
        <Route path="organizations" element={<OrganizationList />} />
        <Route path="organizations/new" element={<OrganizationCreate />} />
        <Route path="organizations/:id/stores/:storeId/edit" element={<StoreEdit />} />
        <Route path="organizations/:id/stores/:storeId/webhook-logs" element={<StoreWebhookLogsPage />} />
        <Route
          path="organizations/:id/stores/:storeId/pos-remittance"
          element={<PosRemittancePage />}
        />
        <Route path="organizations/:id/stores/:storeId" element={<StoreDetail />} />
        <Route path="organizations/:id" element={<OrganizationDetail />} />
        <Route path="organizations/:id/edit" element={<OrganizationEdit />} />
        <Route path="settings" element={<Settings />} />
        <Route path="legal/imprint" element={<LegalImprintPage />} />
        <Route path="legal/pricing" element={<PlatformPricingPage />} />
        <Route path="payment-gateways" element={<PaymentGatewaysPage />} />
        <Route path="withdrawals" element={<WithdrawalsPage />} />
        <Route path="withdrawals/audit/:storeId" element={<StoreAuditPage />} />
        <Route
          path="withdrawals/audit/:storeId/transactions/:txRef"
          element={<StoreAuditTransactionDetailPage />}
        />
        <Route path="newsletters" element={<NewsletterOverviewPage />} />
        <Route path="contact-messages" element={<ContactMessagesPage />} />
        <Route path="platform/team" element={<PlatformTeamPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />}>
    <BrowserRouter>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem
        storageKey="shopora-platform-admin-theme"
        disableTransitionOnChange
      >
        <AuthProvider>
          <OrganizationProvider>
            <ToastProvider>
              <UIProvider>
                <AppRoutes />
              </UIProvider>
            </ToastProvider>
          </OrganizationProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
    </Sentry.ErrorBoundary>
  )
}
